export default __webpack_public_path__ + "media/images/react_icons/wifi-467f924ac614854b81129f26e9a27237.svg";